import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Latin from "./LuckiestGuy-Regular-_gP_1RrxsjcxVyin9l9n_j2hQ952ijl7aSqP.woff2";

export const LuckiestGuyFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
